import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberAccount } from '../../../../models/transactions/member-account';

@Component({
  selector: 'app-internal-portal-affected-accounts-card',
  templateUrl: './internal-portal-affected-accounts-card.component.html',
  styleUrls: ['./internal-portal-affected-accounts-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternalPortalAffectedAccountsCardComponent {
  @Input() memberId!: number;
  @Input() memberName: string = '';
  @Input() accounts: MemberAccount[] = [];
  @Input() isLoading: boolean = false;
}
